import { inject } from '@angular/core';
import { translate, TranslocoService } from '@jsverse/transloco';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export type TranslateParams = Record<string, TranslateKey>;
export type TranslateKey =
  | string
  | { key: string; context: Record<string, unknown> };

export const injectLoadTranslations = () => {
  const ts = inject(TranslocoService);
  const translations$ = ts.load(ts.getActiveLang());

  return <T extends TranslateParams>(
    keys: T,
  ): Observable<Record<string, string>> => {
    const entries = Object.entries(keys);
    return translations$.pipe(
      map(() => {
        return entries.map(([objKey, key]) => {
          if (typeof key === 'string') {
            return [objKey, translate(key)];
          }
          const { key: translateKey, context } = key;
          return [objKey, translate(translateKey, context)];
        });
      }),
      map((res) => Object.fromEntries(res)),
    );
  };
};
